import styled, { css } from 'styled-components';

import { styles } from '../../consts';

import RecoveryPaymentButtonStyleType from './RecoveryPaymentButton.types';

const { white, blueSecondary, fontMBank, progressBarGradient } = styles;

export const RecoverPaymentButton = styled.button<{ customType: string | undefined }>`
  display: inline-block;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: opacity 400ms ease-in-out;
  outline: none;
  font-family: ${fontMBank};
  font-size: 1rem;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.125rem;
  letter-spacing: normal;
  color: ${white};
  height: 2.5rem;
  width: 40%;
  margin-top: 1rem;
  border-radius: 0.6875rem;
  background-image: ${progressBarGradient};

  &::-moz-focus-inner {
    border: 0;
  }
  
   ${props =>
     props.customType === RecoveryPaymentButtonStyleType.PENDING &&
     css`
       font-weight: normal;
       line-height: normal;
       width: 100%;
       height: 2.5rem;
       border-radius: 0.6875rem;
       background: linear-gradient(135deg, #0089ce 0%, #ad1480 100%);
       display: flex;
       flex-direction: row;
     `}
     
       ${props =>
         props.customType === RecoveryPaymentButtonStyleType.RETRY &&
         css`
           font-weight: normal;
           line-height: normal;
           width: 100%;
           background: ${blueSecondary};
           display: flex;
           flex-direction: row;
         `}
  }
`;

export default RecoverPaymentButton;
